/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BaseComponent, Permission} from 'compob2b-libs';
import {catchError, take} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermissionsComponent extends BaseComponent {

  @Input() modelId: number;
  @Input() permissions: Permission;

  changeChecked(permissionKey: string, name: string, type: string, checked: boolean) {
    this.compoApiService
      .post('/dam/change/permission/' + this.modelId, {
        permissionKey,
        name,
        checked,
        type
      })
      .pipe(take(1), catchError(err => this.handleError(err)))
      .subscribe(_ => this.successToast(translations.updated));
  }
}
